import { useId } from "react"

export type PropertyDetails = Record<string, string | number | boolean | string[] | null>
const fields: {key: string; label: string; group: string; type: string; options?: string[]}[] = [
  {
    "key": "publicationStatus",
    "label": "Publication",
    "group": "Publication",
    "type": "select",
    "options": [
      "DRAFT",
      "PUBLISHED",
      "ARCHIVED"
    ]
  },
  {
    "key": "listingSection",
    "label": "Rubrique MaResidence",
    "group": "Publication",
    "type": "select",
    "options": [
      "AUTO",
      "RESIDENCES",
      "MAISONS",
      "TERRAINS"
    ]
  },
  {
    "key": "residenceCategory",
    "label": "Type de séjour",
    "group": "Publication",
    "type": "select",
    "options": [
      "Meuble",
      "Famille",
      "Affaires",
      "Long sejour"
    ]
  },
  {
    "key": "maisonCategory",
    "label": "Type de maison",
    "group": "Publication",
    "type": "select",
    "options": [
      "Appartement",
      "Villa Basse",
      "Duplex",
      "Gros Oeuvre",
      "Cles en Main"
    ]
  },
  {
    "key": "terrainCategory",
    "label": "Type de terrain",
    "group": "Publication",
    "type": "select",
    "options": [
      "Constructible",
      "Agricole",
      "Industriel",
      "Commercial"
    ]
  },
  {
    "key": "shortDescription",
    "label": "Résumé de l’annonce",
    "group": "Présentation et localisation",
    "type": "textarea"
  },
  {
    "key": "coverLabel",
    "label": "Texte sur la photo de couverture",
    "group": "Présentation et localisation",
    "type": "text"
  },
  {
    "key": "badges",
    "label": "Points forts (séparés par des virgules)",
    "group": "Présentation et localisation",
    "type": "list"
  },
  {
    "key": "city",
    "label": "Ville du bien",
    "group": "Présentation et localisation",
    "type": "text"
  },
  {
    "key": "commune",
    "label": "Commune (ex. Yopougon, Songon)",
    "group": "Présentation et localisation",
    "type": "text"
  },
  {
    "key": "address",
    "label": "Adresse publique / repère",
    "group": "Présentation et localisation",
    "type": "text"
  },
  {
    "key": "landAreaSqm",
    "label": "Surface du terrain (m²)",
    "group": "Caractéristiques",
    "type": "number"
  },
  {
    "key": "rooms",
    "label": "Nombre de pièces",
    "group": "Caractéristiques",
    "type": "number"
  },
  {
    "key": "floor",
    "label": "Étage",
    "group": "Caractéristiques",
    "type": "number"
  },
  {
    "key": "floors",
    "label": "Nombre de niveaux",
    "group": "Caractéristiques",
    "type": "number"
  },
  {
    "key": "constructionYear",
    "label": "Année de construction",
    "group": "Caractéristiques",
    "type": "number"
  },
  {
    "key": "parkingSpaces",
    "label": "Places de parking",
    "group": "Caractéristiques",
    "type": "number"
  },
  {
    "key": "pricePerM2",
    "label": "Prix du terrain / m² (FCFA)",
    "group": "Tarifs et conditions",
    "type": "number"
  },
  {
    "key": "weeklyRentalPrice",
    "label": "Location / semaine (FCFA)",
    "group": "Tarifs et conditions",
    "type": "number"
  },
  {
    "key": "securityDeposit",
    "label": "Caution (FCFA)",
    "group": "Tarifs et conditions",
    "type": "number"
  },
  {
    "key": "cleaningFee",
    "label": "Frais de ménage (FCFA)",
    "group": "Tarifs et conditions",
    "type": "number"
  },
  {
    "key": "agencyFee",
    "label": "Frais d’agence (FCFA)",
    "group": "Tarifs et conditions",
    "type": "number"
  },
  {
    "key": "advanceMonths",
    "label": "Mois d’avance",
    "group": "Tarifs et conditions",
    "type": "number"
  },
  {
    "key": "minimumNights",
    "label": "Séjour minimum (nuits)",
    "group": "Tarifs et conditions",
    "type": "number"
  },
  {
    "key": "availableFrom",
    "label": "Disponible à partir du",
    "group": "Séjour",
    "type": "date"
  },
  {
    "key": "checkIn",
    "label": "Heure d’arrivée",
    "group": "Séjour",
    "type": "time"
  },
  {
    "key": "checkOut",
    "label": "Heure de départ",
    "group": "Séjour",
    "type": "time"
  },
  {
    "key": "rentalTerms",
    "label": "Conditions de location / annulation",
    "group": "Séjour",
    "type": "textarea"
  },
  {
    "key": "houseRules",
    "label": "Règlement du logement",
    "group": "Séjour",
    "type": "textarea"
  },
  {
    "key": "petsAllowed",
    "label": "Animaux acceptés",
    "group": "Séjour",
    "type": "boolean"
  },
  {
    "key": "smokingAllowed",
    "label": "Tabac autorisé",
    "group": "Séjour",
    "type": "boolean"
  },
  {
    "key": "landTitle",
    "label": "Document / titre foncier déclaré",
    "group": "Terrain et construction",
    "type": "text"
  },
  {
    "key": "zoning",
    "label": "Usage autorisé / zonage",
    "group": "Terrain et construction",
    "type": "text"
  },
  {
    "key": "roadAccess",
    "label": "Accès au terrain",
    "group": "Terrain et construction",
    "type": "text"
  },
  {
    "key": "waterConnected",
    "label": "Raccordement à l’eau",
    "group": "Terrain et construction",
    "type": "boolean"
  },
  {
    "key": "electricityConnected",
    "label": "Raccordement électrique",
    "group": "Terrain et construction",
    "type": "boolean"
  },
  {
    "key": "video360Url",
    "label": "Lien visite 360°",
    "group": "Médias et contact public",
    "type": "url"
  },
  {
    "key": "videoUrl",
    "label": "Lien vidéo de présentation",
    "group": "Médias et contact public",
    "type": "url"
  },
  {
    "key": "floorPlanUrl",
    "label": "Lien du plan",
    "group": "Médias et contact public",
    "type": "url"
  },
  {
    "key": "publicContactName",
    "label": "Nom du contact public",
    "group": "Médias et contact public",
    "type": "text"
  },
  {
    "key": "publicContactRole",
    "label": "Rôle du contact public",
    "group": "Médias et contact public",
    "type": "text"
  },
  {
    "key": "publicPhone",
    "label": "Téléphone public (indicatif pays)",
    "group": "Médias et contact public",
    "type": "tel"
  },
  {
    "key": "publicWhatsapp",
    "label": "WhatsApp public (indicatif pays)",
    "group": "Médias et contact public",
    "type": "tel"
  }
]

const labels: Record<string,string> = {DRAFT:"Brouillon",PUBLISHED:"Publié sur MaResidence",ARCHIVED:"Archivé",AUTO:"Automatique selon le type de bien",RESIDENCES:"Résidences meublées",MAISONS:"Maisons",TERRAINS:"Terrains",Meuble:"Meublé","Long sejour":"Long séjour","Cles en Main":"Clés en main"}
export const initialPropertyDetails: PropertyDetails = { publicationStatus: "DRAFT", listingSection: "AUTO" }
export function PropertyDetailsFields({value, onChange, disabled = false}: {value: PropertyDetails; onChange: (value: PropertyDetails) => void; disabled?: boolean}) {
  const prefix = useId()
  const groups = Array.from(new Set(fields.map(field => field.group)))
  const update = (key: string, next: PropertyDetails[string]) => onChange({...value, [key]: next})
  return <section className="space-y-4 rounded-2xl border border-slate-200 bg-slate-50 p-4">
    <div><h3 className="font-semibold text-slate-900">Annonce MaResidence</h3><p className="text-sm text-slate-600">Complétez les informations connues. Les coordonnées de contact ci-dessous seront publiques. Publiez lorsque l’annonce est prête.</p></div>
    {groups.map((group,index) => <details key={group} open={index === 0} className="rounded-xl border border-slate-200 bg-white p-4">
      <summary className="cursor-pointer font-medium">{group}</summary>
      <div className="mt-4 grid gap-4 md:grid-cols-2">{fields.filter(field=>field.group===group).map(field => {
        const current = value[field.key]
        const inputValue = Array.isArray(current) ? current.join(", ") : current == null ? "" : String(current)
        const props = {id: `${prefix}-${field.key}`, disabled, className: "mt-1 w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm disabled:bg-slate-100"}
        return <div key={field.key}><label htmlFor={props.id} className="text-sm text-slate-700">{field.label}</label>
          {field.options ? <select {...props} value={inputValue} onChange={e=>update(field.key,e.target.value)}><option value="">Non renseigné</option>{field.options.map(option=><option key={option} value={option}>{labels[option] || option}</option>)}</select> :
          field.type === "boolean" ? <select {...props} value={inputValue} onChange={e=>update(field.key,e.target.value)}><option value="">Non renseigné</option><option value="true">Oui</option><option value="false">Non</option></select> :
          field.type === "textarea" ? <textarea {...props} rows={3} maxLength={5000} value={inputValue} onChange={e=>update(field.key,e.target.value)} /> :
          <input {...props} type={field.type === "list" ? "text" : field.type} min={field.type === "number" ? 0 : undefined} step={field.type === "number" ? "any" : undefined} value={inputValue} onChange={e=>update(field.key,field.type === "list" ? e.target.value.split(",") : e.target.value)} />}
        </div>
      })}</div>
    </details>)}
  </section>
}
